import React from 'react'

import ImgText from '~/components/features/home/imgText'

const HpInfos = ({ data }) => {
  return (
    <div className="hp-infos bg-purple text-white section">
      <div className="fluid-grid">
        <div className="row pb-25 relative">
          <div className="col-12 md-col-9 lg-col-6 lg-col-offset-1 xl-col-5 xl-col-offset-1">
            <span className="text-label text-label--bg bg-blue text-white mb-4 md:mb-12">
              {data.imageTextSectionTags}
            </span>
            <h2 className="title-1-bold">{data.imageTextSectionTitle}</h2>
          </div>

          <img
            className="hp-infos__deco1"
            src="/img/hp-decos/hp-network.svg"
            alt=""
          />
        </div>

        {data.imageTextSectionContents.map((item, i) => {
          const datas = item.sys ? item.fields : item
          return <ImgText key={i} pos={i + 1} item={datas} />
        })}
      </div>
    </div>
  )
}

export default HpInfos
